"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreatePassThroughInvoice = class CreatePassThroughInvoice extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return {
            invoice_type: 'pass_through',
            invoice_id: this.invoice.id,
            client: null,
            ratio: 1,
        };
    }
    labelAlign;
    ux;
    b_7315092382398562_modalBindings;
    b_7789867021953041_dataSource;
    dataMembers = ['formId', 'item', 'labelAlign', 'ux', 'b_7315092382398562_modalBindings', 'b_7789867021953041_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                item: null,
                labelAlign: "right",
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_7789867021953041_dataSource: {
                    name: "suggest_company",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("Invoice", "Create Invoice"),
                    this.invoice.invoice_number,
                ],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4036_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_navigate_4042_getActionArgs($event) {
        return {
            location: {
                name: "app.invoice",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async act_1040167445267876_request_4040_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_4046_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4036 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4036_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4035 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4036,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4035],
        });
        const act_2248226175642056_closeModal_4038 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_4037 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_4038,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4037],
        });
        const act_1040167445267876_navigate_4042 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_4042_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_4041 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_4042,
            event: "success",
            displayName: "navigate",
        });
        const act_1040167445267876_closeComponent_4044 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1040167445267876_success_4043 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_4044,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1040167445267876_request_4040 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_4040_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_4041, evh_1040167445267876_success_4043],
        });
        const evh_1040167445267876_submit_4039 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_4040,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4039],
        });
        const act_1419464017721962_closeModal_4046 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_4046_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_4045 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_4046,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_4045],
        });
        return {
            act_7315092382398562_closeModal_4036,
            evh_7315092382398562_close_4035,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_4038,
            evh_2248226175642056_close_4037,
            evh_2248226175642056_close,
            act_1040167445267876_navigate_4042,
            evh_1040167445267876_success_4041,
            act_1040167445267876_closeComponent_4044,
            evh_1040167445267876_success_4043,
            act_1040167445267876_request_4040,
            evh_1040167445267876_submit_4039,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_4046,
            evh_1419464017721962_clickPreventStop_4045,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_4040,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], CreatePassThroughInvoice.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreatePassThroughInvoice.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreatePassThroughInvoice.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreatePassThroughInvoice.prototype, "onSize", null);
CreatePassThroughInvoice = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreatePassThroughInvoice);
exports.default = CreatePassThroughInvoice;
vue_property_decorator_1.Vue.component("CreatePassThroughInvoice", CreatePassThroughInvoice);
